import ReactGA from "react-ga4";

const initializeAnalytics = () => {
  ReactGA.initialize("G-ZD7FLH0WCL");
};

export default initializeAnalytics;
